<template>
  <div class="steps">
    <p class="steps__title--mobile ml-5 md:ml-0">{{$t('auto_investment.setup.interest_rate.title')}}</p>
    <p class="text-sm text-grey-2 font-semibold lg:font-normal text-opacity-80 text-left mb-12">{{$t('auto_investment.setup.interest_rate.subtitle')}}</p>
    <Slider
      v-model="interestRate"
      :min="autoinvest_min_interest"
      :max="autoinvest_max_interest"
      :step="1"
      :tooltips="true"
      showTooltip="drag"
      :format="formatTooltip"
      class="slider-auto-investment"
    />
    <div class="flex justify-between mt-6">
      <p class="font-bold text-grey-2 text-base">{{autoinvest_min_interest}}%</p>
      <p class="font-bold text-grey-2 text-base">{{autoinvest_max_interest}}%</p>
    </div>
    <p class="text-sm text-grey-3 bg-grey-7 p-4 mt-8 mb-8 rounded-3xl">
      {{ $t('auto_investment.setup.interest_rate.info_box') }} {{roundToOneDecimal(avgInterestRate, 1)}}%
    </p>
    <GpButton
      mobileWidth="w-4/5"
      :disabled="!interestRate"
      class="absolute lg:right-24 mx-auto lg:m-0"
      @click="next"
    >
      {{$t('onboarding.continue')}}
    </GpButton>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import GpButton from '@/components/general/GpButton.vue'
import Slider from '@vueform/slider'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
import {useI18n} from "vue-i18n";

export default {
  components: {
    GpButton,
    Slider
  },
  setup(props, { emit }) {
    const store = useStore()
    const interestRate = ref([2, 10])
    const { roundToOneDecimal } = useGlobalHelpers()
    const i18n = useI18n({ useScope: 'global' })

    const openPopup = () => {
      const popup = {
        align: 'center',
        side: true,
        title: i18n.t('auto_investment.setup.first_step.title'),
        content: document.getElementById('popup-content-auto-investment-details')
          .outerHTML
      }
      store.dispatch('setPopup', popup)
	  }

    const avgInterestRate = computed(() => {
			return store.state.metrics.metrics ? store.state.metrics.metrics.avg_interest_rate : 0
		})

    const autoinvest_min_interest = computed(() => {
      return store.state.general.settings?.autoinvest_min_interest ?? 2
    })

    const autoinvest_max_interest = computed(() => {
      return store.state.general.settings?.autoinvest_max_interest ?? 10
    })

    async function next() {
      store.dispatch('updateNewAutoInvestment', {
        min_interest: interestRate.value[0],
        max_interest: interestRate.value[1],
      })
      emit('next')
    }

    const formatTooltip = (value) => {
      return `${Math.round(value)}%`
    }

    onMounted(async () => {
      await store.dispatch(
        'setRequestSettings',
        'autoinvest_min_interest,autoinvest_max_interest'
      )
      await store.dispatch('fetchProfile')
      interestRate.value[0] = autoinvest_min_interest.value
      interestRate.value[1] = autoinvest_max_interest.value
    })

    return {
      openPopup,
      next,
      formatTooltip,
      interestRate,
      avgInterestRate,
      roundToOneDecimal,
      autoinvest_min_interest,
      autoinvest_max_interest
    }
  }
}
</script>
